/** @format — Footer shell for floating chat input */

import React from "react";
import { cn } from "@/lib/utils";

export default function FloatingChatComposer({ children, className = "" }) {
  return (
    <div className={cn("relative z-10 flex-shrink-0", className)}>
      <div className="px-4 pt-2 pb-2 md:px-8 md:pb-3">
        <div className="mx-auto w-full max-w-3xl">{children}</div>
      </div>
    </div>
  );
}
